import {
  ADD_BAZAAR_INTEREST_REQUEST,
  ADD_BAZAAR_INTEREST_SUCCESS,
  ADD_BAZAAR_INTEREST_FAILURE,
  ADD_BAZAAR_INTEREST_RESET,
} from '../../../types/pvs'

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const addBazaarInterestReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_BAZAAR_INTEREST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case ADD_BAZAAR_INTEREST_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload?.message || "Bazaar interest submitted successfully",
      }

    case ADD_BAZAAR_INTEREST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.payload?.error || "Failed to submit bazaar interest",
      }

    case ADD_BAZAAR_INTEREST_RESET:
      return { ...initialState }

    default:
      return state
  }
}

export default addBazaarInterestReducer
